export class SendMessageOnlyModel {
    IdRequest: number;
    Message: string;
    Rejected: boolean;
    Correction: boolean;
    DataCorrection: boolean;
    DocumentCorrection: boolean;
}